
  import { defineComponent, ref, onMounted, computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { useStore } from 'vuex';
  import { useAbility } from '@casl/vue';
  import { useI18n } from 'vue-i18n/index';
  import { Actions } from '@/store/enums/StoreEnums';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';
  import PaymentLogsAdvancedSearch from '@/components/search/PaymentLogsAdvancedSearch.vue';

  export default defineComponent({
    name: 'payment-logs-listing',
    components: {
      Datatable,
      PaymentLogsAdvancedSearch,
    },
    setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const { can } = useAbility();
      const translate = (key) => (te(key) ? t(key) : key);
      const loading = ref(false);
      const tableHeader = ref([
        { name: translate('ID'), key: 'id', sortable: true },
        { name: translate('createdAt'), key: 'createdAt', sortable: true },
        { name: translate('amount'), key: 'amount', sortable: true },
        { name: translate('status'), key: 'status', sortable: true },
        {
          name: translate('paymentMethod'),
          key: 'paymentMethod',
          sortable: true,
        },
        { name: translate('platform'), key: 'platform', sortable: true },
        { name: translate('chargeId'), key: 'chargeId', sortable: true },
        { name: translate('customerId'), key: 'customerId' },
        { name: translate('service'), key: 'service', sortable: true },
        { name: translate('packageName'), key: 'packageName', sortable: true },
        { name: translate('name'), key: 'name', sortable: true },
        { name: translate('phone'), key: 'phone', sortable: true },
      ]);

      const formatDate = (d) =>
        new Date(d)
          .toLocaleString('sv-SE', { timeZone: 'Asia/Kuwait', hour12: false })
          .slice(0, 16);

      const fetchChargeLogs = async () => {
        loading.value = true;
        await store.dispatch(Actions.GET_CHARGE_LOGS);
        loading.value = false;
      };

      const pageChanged = async (val: number) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_CHARGE_LOGS_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_CHARGE_LOGS);
        loading.value = false;
      };

      const statusClass = (status: string) => {
        switch (status) {
          case 'CAPTURED':
            return 'text-success';
          case 'DECLINED':
            return 'text-danger';
          case 'ABANDONED':
            return 'text-warning';
          default:
            return 'text-muted';
        }
      };
      const onReset = async (value) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_CHARGES_LOGS_FILTER, value);
        await store.dispatch(Actions.UPDATE_CHARGE_LOGS_CURRENT_PAGE, 1);
        await store.dispatch(Actions.GET_CHARGE_LOGS);
        loading.value = false;
      };

      const onTypeChange = async (values) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_CHARGES_LOGS_FILTER, values);
        await store.dispatch(Actions.UPDATE_CHARGE_LOGS_CURRENT_PAGE, 1);
        await store.dispatch(Actions.GET_CHARGE_LOGS);
        loading.value = false;
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          // Swal.fire({
          //   text: translate(error[0]),
          //   icon: 'error',
          //   buttonsStyling: false,
          //   confirmButtonText: translate('tryAgainExcl'),
          //   customClass: {
          //     confirmButton: 'btn fw-bold btn-light-danger',
          //   },
          // });
        }
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('paymentLogs'), [
          translate('subscriptions'),
        ]);
        await fetchChargeLogs();
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');
      });

      return {
        tableData: computed(() => store.getters.chargeLogsList),
        totalItems: computed(() => store.getters.chargeLogsCount),
        tableHeader,
        loading,
        translate,
        can,
        pageChanged,
        statusClass,
        formatDate,
        onTypeChange,
        onReset,
      };
    },
  });
